import { type ICreateWidgetFormSchemaInput } from '@framework/engine/schema/widgets/IWidgetType.ts';
import { setComputedNumberTransform } from '@framework/engine/schema/widgets/repository/computed/number/setComputedNumberTransform.ts';
import { createCommonFormSchema } from '@framework/engine/schema/widgets/repository/inputs/common/createCommonFormSchema.ts';
import { yup } from '@framework/validation/initYup.ts';
import { type IBurdenWidget } from './IBurdenWidget.ts';

export const BurdenWidgetMetaKeys = {
  WidgetId: 'burdenWidget_widgetId',
  MacroBurdenTypeId: 'burdenWidget_macroBurdenTypeId',
};

export function createBurdenWidgetFormSchema({
  widget,
  parentScope,
}: ICreateWidgetFormSchemaInput<IBurdenWidget>) {
  return createCommonFormSchema(
    setComputedNumberTransform(
      widget,
      parentScope,
      yup
        .number()
        .notRequired()
        .meta({
          [BurdenWidgetMetaKeys.WidgetId]: widget.id,
          [BurdenWidgetMetaKeys.MacroBurdenTypeId]: widget.macroBurdenTypeId,
        }),
    ),
    widget,
  );
}
